import { GUIDE_SLUGS, guideMarkdownPath, guidePath } from "../guide/pages.ts";
import type { GuideSlug } from "../guide/pages.ts";
import {
  ANALYTICS_PRODUCT_PATH,
  CAMPAIGNS_PRODUCT_PATH,
  GUIDE_PATH,
  INTELLIGENCE_PRODUCT_PATH,
  REWARDS_PRODUCT_PATH,
  LLMS_FULL_PATH,
  WORKSPACE_PRODUCT_PATH,
  PRICING_PATH,
  PRIVACY_PATH,
  TERMS_PATH,
} from "../routes.ts";

const CATALOG_PATHS = [
  "/",
  PRICING_PATH,
  ANALYTICS_PRODUCT_PATH,
  INTELLIGENCE_PRODUCT_PATH,
  REWARDS_PRODUCT_PATH,
  CAMPAIGNS_PRODUCT_PATH,
  WORKSPACE_PRODUCT_PATH,
  TERMS_PATH,
  PRIVACY_PATH,
  GUIDE_PATH,
];

export const PUBLIC_PATHS = [...CATALOG_PATHS, ...GUIDE_SLUGS.map(guidePath)];

export const TEXT_PATHS = ["/llms.txt", LLMS_FULL_PATH, ...GUIDE_SLUGS.map(guideMarkdownPath)];

export const localizedPath = (path: string, locale: string, baseLocale: string): string => {
  if (locale === baseLocale) return path;
  return path === "/" ? `/${locale}` : `/${locale}${path}`;
};

export const publicPathsIn = (
  locale: string,
  baseLocale: string,
  written: (locale: string, slug: GuideSlug) => boolean,
): readonly string[] =>
  locale === baseLocale
    ? PUBLIC_PATHS
    : [...CATALOG_PATHS, ...GUIDE_SLUGS.filter((slug) => written(locale, slug)).map(guidePath)];

export const OG_IMAGE = { path: "/og.png", width: 1200, height: 630 } as const;

export const SITE_ORIGIN = "https://colossus.dislace.com";

export const APP_SEGMENTS: readonly string[] = ["added", "admin", "m", "servers", "t", "welcome"];

export const isAppPath = (pathname: string): boolean => {
  const [, segment] = pathname.split("/");
  return segment !== undefined && APP_SEGMENTS.includes(segment);
};
